exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes spinAround-726afe06{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.spinner[data-v-726afe06]{animation:spinAround-726afe06 .6s linear infinite;border-radius:290486px;-webkit-user-select:none;-moz-user-select:none;user-select:none;border-color:transparent transparent #999faa #999faa;border-style:solid;border-width:3px;display:inline-block;vertical-align:middle;height:18px;width:18px}", ""]);

// exports
